module.exports = __webpack_public_path__ + "img/magento-code-review.e9b836f2.webp";